import 'zod/compile';
import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../../route';

const CreateTransferOrderPage = lazyRouteComponent(
  () => import('./CreateTransferOrderPage'),
  'CreateTransferOrderPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/internal-transfers/new',
  validateSearch: z.object({ draftId: z.uuid().optional() }),
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAllOf: [
          { action: Action.Read, subject: Subject.Inventory },
          { action: Action.Read, subject: Subject.PurchaseOrder },
          { action: Action.Create, subject: Subject.PurchaseOrder },
        ],
      },
    },
  },
  component: CreateTransferOrderPage,
  loader: () => ({
    crumb: msg('Create Transfer Order', { context: 'page breadcrumb' }),
    crumbAncestors: [
      {
        title: msg('Transfer Order Status', { context: 'page breadcrumb' }),
        path: '/procurement/transfer-order-status',
      },
    ],
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
